<template>
  <div class="cell-row" @click="cellClick">
    <div class="cell-row-content">
        
        <div class="cell-left">
            <div class="cell-icon" v-if="icon">
                <img :src="icon" class="icon" />
            </div>
            {{name}}
        </div>
        <div class="cell-content">
            <slot ></slot>
        </div>
        <div class="cell-center" v-if="rightIcon">
            <img class="cell-right-icon" src="../../picture/my/cell-right.png" />
        </div>
    </div>
</div>
</template>

<script>
export default {
  name: 'pi-cell-row',
  data () {
    return {

    };
  },
  methods: {
    cellClick () {
      if (this.url === '') {
        this.$emit('click');
      } else {
        this.$router.push(this.url);
      }
    }
  },
  props: {
    icon: {
      type: String,
      default: ''
    },
    url: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    rightIcon: {
      type: Boolean,
      default: true
    },
  }
};
</script>

<style lang="less" scoped>
.cell-row{
  background-color: #fff;
  padding: 0rem 0.20rem;
}
.cell-row:active{
  background-color: #f5f5f5;
}
.cell-row-content{
  display: flex;
  line-height: 0.42rem;
  font-size: 0.30rem;
  border-bottom: 0.01rem solid #EEEEEE;
  padding: 0.26rem 0;
}
.cell-row-content .cell-icon{
  width: 0.42rem;
  height: 0.42rem;
  margin-right: 0.20rem;
}
.cell-row-content .cell-left{
  
  color: #333;
}
.cell-content{
  flex: 1;
  color: #999999;
  text-align: right;
}
.cell-right-icon{
  width: 0.28rem;
  height: 0.28rem;
}
.cell-center{
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
